import React, {useState} from 'react';
function UrlEditorGoogleAttributes ({googleAttribute, cmAttribute, onChange, onDelete}){

    const currentValue = cmAttribute.urlValues ? cmAttribute.urlValues[0].url : ""
    const attributeId = googleAttribute.attributeId
    const handleOptionChange = (e) => {
        const cmGoogleAttribute = {attributeId: googleAttribute.attributeId,
            valueType: googleAttribute.valueType,  urlValues: [{url:e.target.value}]}

            onChange(cmGoogleAttribute)
    };


    const handleClick = () => {
        onDelete(cmAttribute)
    }

    const isValidUrl = (string) => {
        try {
            new URL(string);
        } catch (_) {
            return false;
        }
        return true;
    }

    return <div>
        <table style={{"width": "100%"}}>
            <tbody style={{"width": "100%"}}>
            <tr>
                <td style={{"width": "180px"}}>{/* Set width on first column so everything lines up nicely */}{googleAttribute.displayName}</td>
                <td style={{"width": "200px"}}>
                    <input type="url"
                           id={attributeId}
                           style={{"width": "200px"}}
                           name={attributeId}
                           key = {attributeId}
                           placeholder="https://example.com"
                           value={currentValue}
                           onChange={handleOptionChange}
                           required/>
                </td>
                <td>
                    <label>
                        <button type="button" className="btn btn-light"
                                onClick={handleClick}>
                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-x-circle-fill"
                                 fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd"
                                      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.146-3.146a.5.5 0 0 0-.708-.708L8 7.293 4.854 4.146a.5.5 0 1 0-.708.708L7.293 8l-3.147 3.146a.5.5 0 0 0 .708.708L8 8.707l3.146 3.147a.5.5 0 0 0 .708-.708L8.707 8l3.147-3.146z"/>
                            </svg>
                        </button>
                    </label>
                </td>
            </tr>
            </tbody>
        </table>
        {!isValidUrl(currentValue) && <small id="boolError" className="text-danger">
            Must enter a valid URL.
        </small>}

    </div>

}

export default UrlEditorGoogleAttributes;